import apiService from "../../api/api.service";
import {
  GenderResponse,
  UpdateGenderRequest,
  UpdateGenderResponse,
} from "./gender.types";

export const fetchGenders = (): Promise<GenderResponse> => {
  return apiService.get<GenderResponse>("/customers/genders");
};

export const updateGender = (
  data: UpdateGenderRequest,
): Promise<UpdateGenderResponse> => {
  return apiService.post<UpdateGenderResponse, UpdateGenderRequest>(
    "/customers/update-gender",
    data,
  );
};
